import { Card, Collapse, Link } from '@ksyos/design-system';
import { isEqual } from 'lodash';
import { useState } from 'react';
import type { IAddCarePathSettings } from '../../../../../../common/interfaces/addCarePathSettings';
import type { IOrganizationAddCarePathState } from '../../../../interfaces/organizationAddCarePathState';
import type { IProfileGroupedByServiceGroup } from '../steps/AssignRoles';
import { translateKey } from '../../../../../translate';
import { RoleCardItem } from './RoleCardItem';

interface ICollapsibleRolesCardProps {
    addCarePathState: IOrganizationAddCarePathState;
    defaultProfileSettings: { [key: string]: IAddCarePathSettings } | undefined;
    onChangePractitioner: (profileId: string) => void;
    onClickSettings: (profileId: string) => void;
    serviceGroupWithProfiles: IProfileGroupedByServiceGroup;
}

export function CollapsibleRolesCard(props: ICollapsibleRolesCardProps) {
    const [isOpen, toggleOpen] = useState(false);

    const roleCardItems: Function = (): JSX.Element[] => {
        // workaround for CS-11059
        return props.serviceGroupWithProfiles.profiles.map((profile, i) => {
            return (
                <RoleCardItem
                    addCarePathState={props.addCarePathState}
                    isSameAsDefaultSettings={isEqual(profile.settings, props.defaultProfileSettings?.[profile.id])}
                    key={profile.id}
                    onChangePractitioner={props.onChangePractitioner}
                    onClickSettings={props.onClickSettings}
                    profile={profile}
                />
            );
        });
    };

    return (
        <Card>
            <Card.Header title={props.serviceGroupWithProfiles.serviceGroup.name} />
            <Collapse isOpen={isOpen}>
                <Card.Body>{roleCardItems()}</Card.Body>
            </Collapse>
            <Card.Footer>
                <Link
                    color="minimal"
                    fontWeight="normal"
                    iconLeft={isOpen ? 'caret-up' : 'caret-down'}
                    onClick={() => toggleOpen(!isOpen)}
                    size="sm"
                    variant="button"
                >
                    {isOpen ? translateKey('common.fold') : translateKey('organization.showRoles')}
                </Link>
            </Card.Footer>
        </Card>
    );
}
